module.exports = __webpack_public_path__ + "img/activeazby.045ac2dc.png";